import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import JSZip from 'jszip';

@Injectable({
    providedIn: 'root',
})
export class FileDownloadService {
    constructor(private http: HttpClient) { }
    downloadFiles(fileUrls: string[], zipFileName: string, altUrls:string[], fileNames: string[]): void {
        const zip = new JSZip();
    
        const downloadPromises = fileUrls.map((url, index) => {
          return this.http.get(url, { responseType: 'arraybuffer' })
            .toPromise()
            .then((fileData: any) => {
              const fileName = fileNames[index];
              zip.file(fileName, fileData);
            })
            .catch((error: HttpErrorResponse) => {
              if (error.status === 404 || error.status === 403) {
                // console.error(`File not found at ${url}`); //__CONSOLE_LOG__
                // console.log(altUrls[index]) //__CONSOLE_LOG__
                // Replace the URL with another URL if the file is not found
                return this.http.get(altUrls[index], { responseType: 'arraybuffer' })
                  .toPromise()
                  .then((fileData:any) => {
                    const fileName = fileNames[index];
                    zip.file(fileName, fileData);
                  })
                  .catch((error) => {
                    // console.error(`Failed to download placeholder file for ${url}:`, error); //__CONSOLE_LOG__
                    return Promise.reject(error); // Return a rejected Promise
                  });
              } else {
                // console.error(`Error downloading file from ${url}:`, error); //__CONSOLE_LOG__
                return Promise.reject(error); // Return a rejected Promise
              }
            });
        });
    
        Promise.all(downloadPromises).then(() => {
          zip.generateAsync({ type: 'blob' })
            .then((blob) => {
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = zipFileName + '.zip';
              link.click();
            });
        });
      }
    }